import { render, staticRenderFns } from "./ProductOrderCofaDocumentPopUp.vue?vue&type=template&id=21e98142&scoped=true&"
import script from "./ProductOrderCofaDocumentPopUp.vue?vue&type=script&lang=js&"
export * from "./ProductOrderCofaDocumentPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderCofaDocumentPopUp.vue?vue&type=style&index=0&id=21e98142&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e98142",
  null
  
)

export default component.exports